PJQ.views.drawings.EditAnnotation = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'annotation-edit'),
        subTemplates: {
            textSizePicker: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'text-size-picker')
        },
        focusText: false,
        isEditLink: false,
        onShapeChange: null,
        onPublish: null,
        canEdit: false,
        onDelete: null,
        onClose: null,
        onAnnotationDataChange: null,
        onAttachmentChange: null,
        onDrawingSelected: null
    },
    events: {
        "click .text-size-picker>button": "textSizeClicked",
        "click .version-drawing-outer": "drawingClicked",
        "click .btn-edit-link": "editLink",
        "click .btn-save-link": "saveLink",
        "click .btn-cancel-link": "cancelEditLink",
        "click .view-punch-list-item": "viewPunchListItemClicked",
        "click .view-action-item": "viewActionItemClicked",
        "click .btn-publish-annotation": "publish",
        "click .btn-delete-annotation": "delete",
        "click .btn-close-annotation": "close"
    },
    beforeFirstRender: function () {
        let type = this.model.get('type');
        if (type === PJQ.constants.drawings.annotationTypes.LINK_RECTANGLE || type === PJQ.constants.drawings.annotationTypes.LINK_ELLIPSE || type === PJQ.constants.drawings.annotationTypes.LINK_CLOUD) {
            if (this.model.get('refType') == null) {
                this.model.set('refType', PJQ.constants.drawings.refTypes.DRAWING);
            }
        }
    },
    renderData: function () {
        return {
            model: this.model,
            versions: this.options.versions,
            context: this.options.context,
            isEditLink: this.options.isEditLink,
            canEdit: this.options.canEdit,
            isAdmin: this.options.isAdmin
        };
    },
    afterRender: function () {
        let type = this.model.get('type');
        if (type === PJQ.constants.drawings.annotationTypes.LINK_RECTANGLE || type === PJQ.constants.drawings.annotationTypes.LINK_ELLIPSE || type === PJQ.constants.drawings.annotationTypes.LINK_CLOUD) {
            new PJQ.inputs.Selectpicker({
                el: this.$('.select-link-ref-type'),
                defaultValue: this.model.get('refType'),
                onChange: _.bind(function (value) {
                    this.model.set('refType', value);
                    this.render();
                }, this)
            });

            let choices = _.map(_.sortBy(this.options.versions.getUniqueDrawings(), (drawing) => {
                return drawing.get('sortOrder');
            }), (drawing) => {
                return {
                    id: drawing.id,
                    name: drawing.get('name')
                };
            });
            this.refIdPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.select-link-ref-id'),
                defaultValue: this.model.get('refId'),
                isIntChoices: true,
                isLiveSearch: true,
                choices: choices,
                size: 15,
                onChange: _.bind(function (value) {
                    if (value > 0 && this.model.get('refId') == null) {
                        this.model.set('refId', value);
                        this.render();
                        this.onAnnotationDataChange();
                    }
                }, this)
            });
        } else if (type === PJQ.constants.drawings.annotationTypes.PHOTO) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.annotation-file-uploader'),
                collection: this.model.attachments,
                previewImageDimension: 140,
                canUpload: this.options.canEdit,
                canDelete: this.options.canEdit,
                onSuccess: _.bind(function () {
                    if (typeof this.options.onAttachmentChange === 'function') {
                        this.options.onAttachmentChange(this.model);
                    }
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.id > 0) {
                        attachment.set('isDeleted', true);
                    } else {
                        this.model.attachments.remove(attachment);
                    }
                    this.model.isDirty = true;

                    attachment.set('drawingId', this.model.id);
                    if (typeof this.options.onAttachmentChange === 'function') {
                        this.options.onAttachmentChange(this.model);
                    }
                    callback();
                }, this)
            });
        } else if (type === PJQ.constants.drawings.annotationTypes.TEXT) {
            this.renderTextSizePicker();

            if (this.options.focusText) {
                this.$('.input-annotation-text').focus();
            }
        } else if (type === PJQ.constants.drawings.annotationTypes.PIN_PUNCH_LIST_ITEM) {
            this.renderPunchListDetails();
        } else if (type === PJQ.constants.drawings.annotationTypes.PIN_ACTION_ITEM) {
            this.renderActionItemDetails();
        }

        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
                'textarea'
            ],
            afterChange: _.bind(function (_, attribute) {
                if (attribute === 'text') {
                    this.onShapeChange();
                } else {
                    this.onAnnotationDataChange();
                }
            }, this)
        });
    },
    editLink: function (e) {
        e.stopPropagation();
        this.options.isEditLink = true;
        this.render();
    },
    saveLink: function () {
        this.model.set('refId', this.refIdPicker.getValue());
        this.onAnnotationDataChange();
        this.cancelEditLink();
    },
    cancelEditLink: function () {
        this.options.isEditLink = false;
        this.render();
    },
    drawingClicked: function () {
        if (typeof this.options.onDrawingSelected === 'function') {
            let drawing = this.options.versions.getDrawing(this.model.get('refId'));
            if (drawing != null) {
                this.options.onDrawingSelected(drawing);
            }
        }
    },
    renderPunchListDetails: function () {
        let canAdd = this.options.project.permissions.hasPermission('punchList.canAdd'),
            choices,
            fnMapItems = () => {
                let items = _.map(this.punchListItems.models, (punchListItem) => {
                    return {
                        id: punchListItem.id,
                        name: '<strong>' + punchListItem.get('itemNumber') + '</strong>' + " - " + punchListItem.get('title')
                    };
                });
                if (!canAdd) {
                    return items;
                }

                return [
                    {
                        name: '',
                        choices: [
                            {
                                id: 0,
                                name: '<i class="fal fa-plus mr-1"></i>New Item'
                            }
                        ]
                    },
                    {
                        name: '',
                        choices: items
                    }
                ];
            }

        if (!(this.model.get('refId') > 0)) {
            if (this.punchListItems != null) {
                choices = fnMapItems();
            } else {
                choices = [];
            }

            let $selectItem = this.$('.select-punch-list-item'),
                punchListItemSelect = new PJQ.inputs.Selectpicker({
                    el: $selectItem,
                    isLiveSearch: true,
                    choices: choices,
                    isIntChoices: true,
                    pickerWidth: '275px',
                    onChange: (value) => {
                        if (value === 0) {
                            punchListItemSelect.setValue(null);
                            this.newPunchListItem();
                            return;
                        }

                        let item = this.punchListItems.get(value);
                        if (item == null) {
                            return;
                        }

                        this.model.setPunchListItem(item);
                        this.render();
                        this.onAnnotationDataChange();
                    }
                });

            let fnUpdateChoices = () => {
                punchListItemSelect.updateChoices(fnMapItems());
                setTimeout(() => {
                    punchListItemSelect.toggle();
                }, 100);
            };
            if (this.punchListItems != null) {
                fnUpdateChoices();
            } else {
                let loader = new PJQ.Loader($selectItem);
                this.options.project.fetchPunchListItems((punchListItems) => {
                    loader.remove();
                    this.punchListItems = punchListItems;
                    fnUpdateChoices();
                });
            }
        }
    },
    newPunchListItem: function () {
        let newItem = new PJQ.models.punchlists.PunchlistItem({
            projectId: this.options.project ? this.options.project.id : null
        });
        this.viewPunchListItem(newItem);
    },
    viewPunchListItemClicked: function (e) {
        let target = $(e.currentTarget),
            id = target.data('id'),
            item = this.model.punchListItem;
        if (item == null) {
            item = new PJQ.models.punchlists.PunchlistItem({
                id: id
            })
        }
        this.viewPunchListItem(item);
    },
    viewPunchListItem: function (item) {
        new PJQ.views.punchlists.PunchlistItemEditorModal({
            model: item,
            collection: this.punchListItems,
            project: this.options.project,
            onSave: () => {
                this.model.setPunchListItem(item);
                this.render();
                this.onAnnotationDataChange();
            }
        });
    },
    renderActionItemDetails: function () {
        let canAdd = this.options.project.permissions.hasPermission('actionItems.canAdd'),
            choices,
            fnMapItems = () => {
                let items = _.map(this.actionItems.models, (actionItem) => {
                    return {
                        id: actionItem.id,
                        name: '<strong>' + actionItem.get('itemNumber') + '</strong>' + " - " + actionItem.get('title')
                    };
                });
                if (!canAdd) {
                    return items;
                }

                return [
                    {
                        name: '',
                        choices: [
                            {
                                id: 0,
                                name: '<i class="fal fa-plus mr-1"></i>New Item'
                            }
                        ]
                    },
                    {
                        name: '',
                        choices: items
                    }
                ];
            }

        if (this.model.actionItem == null) {
            if (this.actionItems != null) {
                choices = fnMapItems();
            } else {
                choices = [];
            }

            let $selectItem = this.$('.select-action-item'),
                actionItemSelect = new PJQ.inputs.Selectpicker({
                    el: $selectItem,
                    isLiveSearch: true,
                    choices: choices,
                    isIntChoices: true,
                    pickerWidth: '275px',
                    onChange: (value) => {
                        if (value === 0) {
                            actionItemSelect.setValue(null);
                            this.newActionItem();
                            return;
                        }

                        let item = this.actionItems.get(value);
                        if (item == null) {
                            return;
                        }

                        this.model.setActionItem(item);
                        this.render();
                        this.onAnnotationDataChange();
                    }
                });

            let fnUpdateChoices = () => {
                actionItemSelect.updateChoices(fnMapItems());
                setTimeout(() => {
                    actionItemSelect.toggle();
                }, 100);
            };
            if (this.actionItems != null) {
                fnUpdateChoices();
            } else {
                let loader = new PJQ.Loader($selectItem);
                this.options.project.fetchActionItems((actionItems) => {
                    loader.remove();
                    this.actionItems = actionItems;
                    fnUpdateChoices();
                });
            }
        }
    },
    newActionItem: function () {
        let newItem = new PJQ.models.actionItems.ActionItem({
            projectId: this.options.project ? this.options.project.id : null
        });
        this.viewActionItem(newItem);
    },
    viewActionItemClicked: function (e) {
        let target = $(e.currentTarget),
            id = target.data('id'),
            item = this.model.actionItem
        if (item == null) {
            item = new PJQ.models.actionItems.ActionItem({
                id: id
            })
        }
        this.viewActionItem(item);
    },
    viewActionItem: function (item) {
        new PJQ.views.actionItems.ActionItemEditorModal({
            model: item,
            collection: this.actionItems,
            project: this.options.project,
            onSave: () => {
                this.model.setActionItem(item);
                this.render();
                this.onAnnotationDataChange();
            }
        });
    },
    renderTextSizePicker: function () {
        this.renderSubTemplate(false, this.options.subTemplates.textSizePicker, this.$('.text-size-outer'), {
            textSize: this.model.get('textSize')
        });
    },
    textSizeClicked: function (e) {
        e.stopPropagation();
        this.model.set('textSize', parseInt($(e.currentTarget).data('textSize')));
        this.renderTextSizePicker();
        this.onShapeChange();
    },
    onAnnotationDataChange: function () {
        if (typeof this.options.onAnnotationDataChange === 'function') {
            this.options.onAnnotationDataChange(this.model);
        }
    },
    onShapeChange: function () {
        if (typeof this.options.onShapeChange === 'function') {
            this.options.onShapeChange(this.model);
        }
    },
    publish: function () {
        if (typeof this.options.onPublish === 'function') {
            this.options.onPublish(this.model);
        }
        this.render();
    },
    delete: function () {
        if (typeof this.options.onDelete === 'function') {
            this.options.onDelete(this.model);
        }
        this.close();
    },
    close: function () {
        this.remove();
        if (typeof this.options.onClose === 'function') {
            this.options.onClose(this.model);
        }
    }
});

